import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Alert,
} from "reactstrap";

import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";

import { contactsCreate, contactsClearCreated } from "../../../store/actions";

import Loader from "../../../components/Common/Loader";
import ButtonVolver from "../../../components/ButtonVolver";

// Estilos CSS personalizados
const customStyles = `
  .user-add-container {
    background: #F1F8E9;
    min-height: 100vh;
    padding: 20px 0;
  }

  .bg-gradient-primary {
    background:#C8E6C9;
  }

  .section-header {
    display: flex;
    background: #F1F8E9
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
  }

  .section-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
  }

  .form-control-modern {
    border: 2px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #fff;
  }

  .form-control-modern:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
    background: #fff;
  }

  .form-select.form-control-modern {
    border: 2px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
    background: #fff;
  }

  .btn-modern {
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
  }

  .btn-modern:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  .card {
    border-radius: 15px;
    overflow: hidden;
  }

  .shadow-sm {
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08) !important;
  }

  .border-0 {
    border: none !important;
  }

  .action-buttons .btn {
    font-weight: 600;
  }

  .form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
  }

  .text-primary {
    color: #667eea !important;
  }

  .text-success {
    color: #28a745 !important;
  }

  .bg-primary {
    background-color: #667eea !important;
  }

  .bg-success {
    background-color: #28a745 !important;
  }
`;

// Inyectar estilos
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = customStyles;
  document.head.appendChild(styleElement);
}

const UserAdd = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const theme = useSelector((state) => state.theme.theme) || "light";
  
  const optionGroupTipoIdentificacion = [
    {
      options: [
        { label: "Cédula Ciudadanía", value: "CEDULA" },
        { label: "Pasaporte", value: "PASAPORTE" },
        { label: "Cedula de Extranjería", value: "CEDULA_EXTRANJERIA" },
        { label: "Otro", value: "OTRO" },
      ],
    },
  ];

  const [selectedTipoIdentificacion, setSelectedTipoIdentificacion] = useState(null); 
  function handleSelectTipoIdentificacion(selectedTipoContacto) {
    setSelectedTipoIdentificacion(selectedTipoContacto.value);
  } 

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirm_password: "",
    first_name: "",
    last_name: "",
    documentNumber: "",
    contactType: "PERSONA NATURAL",
    codigoCAUAGENT: "",
    codigo_visitador: "",
    cargo: ""
  });

  const { username, password, confirm_password, first_name, last_name, documentNumber } = formData;

  // Limpiar el estado de contactsCreated cuando se monta el componente
  useEffect(() => {
    dispatch(contactsClearCreated());
  }, [dispatch]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    props.contactsCreate({
      username,
      password,
      confirm_password,
      first_name,
      last_name,
      documentNumber,
      contactType: 'PERSONA NATURAL',
      documentType: selectedTipoIdentificacion,
    });
  };

  const redirect = () => {
    history.push("/users");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cuidad Limpia| Usuarios </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Col className="d-flex gap-3 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Crear Usuario
            </span>
          </Col>
          {props.loading ? (
            <Loader />
          ) : (
            <div className="user-add-container">
              <div className="row">
                <div className="col-lg-8 mx-auto">
                  {props.contactsCreated.id ? (
                    <SweetAlert
                      title="¡Perfecto!"
                      success
                      timeout={2000}
                      showConfirm={false}
                      onConfirm={() => {
                        redirect();
                      }}
                    >
                      Se ha agregado el usuario exitosamente
                    </SweetAlert>
                  ) : null}

                  {/* Mostrar errores del servidor */}
                  {props.error && Object.keys(props.error).length > 0 && (
                    <Alert color="danger" className="mb-4 border-0 shadow-sm">
                      <div className="d-flex align-items-center">
                        <i className="mdi mdi-alert-circle-outline me-2" style={{ fontSize: '1.5rem' }}></i>
                        <div>
                          <strong>Error al crear usuario:</strong>
                          <ul className="mb-0 mt-2">
                            {Object.entries(props.error).map(([field, messages]) => (
                              <li key={field}>
                                <strong>{field}:</strong> {Array.isArray(messages) ? messages.join(', ') : messages}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </Alert>
                  )}

                  <Form onSubmit={onSubmit}>
                    {/* Información Básica */}
                    <Card className="mb-4 border-0 shadow-sm">
                      <CardHeader className="border-bottom-0 pb-0">
                        <div className="section-header">
                          <div className="section-icon bg-primary">
                            <i className="mdi mdi-account-circle text-white"></i>
                          </div>
                          <div>
                            <h5 className="mb-1 fw-bold">Información Básica</h5>
                            <p className="text-muted small mb-0">Datos principales del usuario</p>
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody className="pt-3">
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label for="username" className="form-label fw-semibold">
                                <i className="mdi mdi-email me-1 text-primary"></i>
                                Correo Electrónico <span className="text-danger">*</span>
                              </Label>
                              <Input
                                id="username"
                                name="username"
                                type="email"
                                placeholder="correo@ejemplo.com"
                                onChange={onChange}
                                value={username}
                                className="form-control-modern"
                                invalid={props.error.username ? true : false}
                                required
                              />
                              <FormFeedback>{props.error.username}</FormFeedback>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label for="first_name" className="form-label fw-semibold">
                                <i className="mdi mdi-account-outline me-1 text-primary"></i>
                                Nombres
                              </Label>
                              <Input
                                id="first_name"
                                name="first_name"
                                type="text"
                                placeholder="Nombres"
                                onChange={onChange}
                                value={first_name}
                                className="form-control-modern"
                                invalid={props.error.first_name ? true : false}
                              />
                              <FormFeedback>{props.error.first_name}</FormFeedback>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label for="last_name" className="form-label fw-semibold">
                                <i className="mdi mdi-account-outline me-1 text-primary"></i>
                                Apellidos
                              </Label>
                              <Input
                                id="last_name"
                                name="last_name"
                                type="text"
                                placeholder="Apellidos"
                                onChange={onChange}
                                value={last_name}
                                className="form-control-modern"
                                invalid={props.error.last_name ? true : false}
                              />
                              <FormFeedback>{props.error.last_name}</FormFeedback>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label for="documentType" className="form-label fw-semibold">
                                <i className="mdi mdi-card-account-details me-1 text-primary"></i>
                                Tipo de identificación
                              </Label>
                              <Select
                                id="documentType"
                                name="documentType"
                                onChange={handleSelectTipoIdentificacion}
                                options={optionGroupTipoIdentificacion}
                                placeholder={'Seleccione'}
                                className="react-select-container"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <div className="mb-0">
                              <Label for="documentNumber" className="form-label fw-semibold">
                                <i className="mdi mdi-identifier me-1 text-primary"></i>
                                Documento
                              </Label>
                              <Input
                                id="documentNumber"
                                name="documentNumber"
                                type="number"
                                placeholder="Número de documento"
                                onChange={onChange}
                                value={documentNumber}
                                className="form-control-modern"
                                invalid={props.error.documentNumber ? true : false}
                              />
                              <FormFeedback>{props.error.documentNumber}</FormFeedback>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    {/* Información de Seguridad */}
                    <Card className="mb-4 border-0 shadow-sm">
                      <CardHeader className="border-bottom-0 pb-0">
                        <div className="section-header">
                          <div className="section-icon bg-success">
                            <i className="mdi mdi-lock text-white"></i>
                          </div>
                          <div>
                            <h5 className="mb-1 fw-bold">Información de Seguridad</h5>
                            <p className="text-muted small mb-0">Credenciales de acceso</p>
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody className="pt-3">
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label for="password" className="form-label fw-semibold">
                                <i className="mdi mdi-lock-outline me-1 text-success"></i>
                                Contraseña <span className="text-danger">*</span>
                              </Label>
                              <Input
                                id="password"
                                name="password"
                                type="password"
                                placeholder="Contraseña"
                                onChange={onChange}
                                value={password}
                                className="form-control-modern"
                                invalid={props.error.password ? true : false}
                                required
                              />
                              <FormFeedback>{props.error.password}</FormFeedback>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-0">
                              <Label for="confirm_password" className="form-label fw-semibold">
                                <i className="mdi mdi-lock-check me-1 text-success"></i>
                                Confirmación de Contraseña <span className="text-danger">*</span>
                              </Label>
                              <Input
                                id="confirm_password"
                                name="confirm_password"
                                type="password"
                                placeholder="Confirmar contraseña"
                                onChange={onChange}
                                value={confirm_password}
                                className="form-control-modern"
                                invalid={props.error.confirm_password ? true : false}
                                required
                              />
                              <FormFeedback>{props.error.confirm_password}</FormFeedback>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    {/* Botones de Acción */}
                    <Card className="border-0 shadow-sm">
                      <CardBody>
                        <Row className="justify-content-center">
                          <Col md={6} className="d-flex justify-content-center gap-3 action-buttons">
                            <Link 
                              className="btn btn-secondary btn-modern text-dark" 
                              to="/users"
                              style={{ minWidth: '120px' }}
                            >
                              <i className="mdi mdi-arrow-left me-1"></i>
                              Volver
                            </Link>
                            <Button 
                              color="primary" 
                              type="submit" 
                              className="btn-modern"
                              style={{ minWidth: '120px' }}
                            >
                              <i className="mdi mdi-check me-1"></i>
                              Crear Usuario
                            </Button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Form>
                </div>
              </div>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, contactsCreated } = state.Contacts;
  const { rol } = state.Rol;
  return { error, loading, contactsCreated, rol };
};

UserAdd.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  contactsCreated: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, { contactsCreate, contactsClearCreated })(UserAdd));
